import {createNamespacedHelpers} from 'vuex'
import {namespace} from '../vuexstore'
import {default as cardStore, namespace as cardNamespace} from '../vuexstore/modules/giftcard'
const {mapGetters, mapActions} = createNamespacedHelpers([namespace, cardNamespace].join('/'))
import { required, email, sameAs } from 'vuelidate/lib/validators'

/**
 *
 * @param options{storePath: '', get: '', set: '', prefix: '', suffix: ''}
 * @returns {*}
 */
export const mapState = (options) => {
  const {storePath, prefix = '', suffix = ''} = options
  const states =  _.reduce(storePath, (fns, item, key) => {
    fns[prefix + key + suffix] = {
      get() {
        return this.giftCardInput(key)
      },
      set(value) {
        this.setGiftCardInput({[key]: value})
      }
    }
    return fns
  }, {})
  return states
}

export default {
  validations: {
    productId: {
      required,
    },
    firstName: {
      required,
    },
    lastName: {
      required,
    },
    email: {
      required,
      email,
    },
    emailConfirmation: {
      required,
      confirmed: sameAs('email'),
    },
    phone: {
      required,
    },
    phoneConfirmation: {
      required,
      confirmed: sameAs('phone'),
    },
    personalDetails: [
      'firstName', 'lastName', 'email', 'emailConfirmation', 'phone', 'phoneConfirmation',
    ],
    gifteeFirstName: {
      required,
    },
    gifteeLastName: {
      required,
    },
    gifteeEmail: {
      required,
      email,
    },
    gifteeEmailConfirmation: {
      required,
      confirmed: sameAs('gifteeEmail'),
      email,
    },
    gifteePhone: {
      required,
    },
    gifteePhoneConfirmation: {
      required,
      confirmed: sameAs('gifteePhone'),
    },
    gifteeDetails: [
      'gifteeFirstName', 'gifteeLastName', 'gifteeEmail', 'gifteeEmailConfirmation', 'gifteePhone', 'gifteePhoneConfirmation'
    ],
  },

  computed: {
    ...mapGetters(Object.keys(cardStore.getters)),
    ...mapState({ storePath: cardStore.state.form }),

    disabledCardProcessor() {
      return this.$v.productId.$error || this.$v.personalDetails.$error || (!!this.giftee && this.$v.gifteeDetails.$error)
    },
  },

  methods: {
    ...mapActions(Object.keys(cardStore.actions)),
  },
}

